import React from "react";
import { Card, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { isMobile } from "react-device-detect";
function SkeletonAmusementCardItem() {
  return isMobile ? (
    <Col xs="6" sm="4" md="3" className="mt-2">
      <Card className="bg-white rounded-3 p-2">
        <Card.Body className="p-0 text-center">
          <Skeleton height={80} width="100%" className="mt-2"></Skeleton>

          <div className=" ">
            <Skeleton height={20} width="100%" className="mt-2"></Skeleton>
            <Skeleton height={20} width="100%" className="mt-2"></Skeleton>
            <Skeleton height={20} width="100%" className="mt-2"></Skeleton>
          </div>
        </Card.Body>
        <Card.Footer className="bg-white border-top-0 pt-0 px-0 pb-0 rounded-3">
          <Skeleton height={37} width="100%" className="mt-2"></Skeleton>
        </Card.Footer>
      </Card>
    </Col>
  ) : (
    <div className="mt-2  col-custom">
      <Card className="bg-white rounded-3 p-2">
        <Card.Body className="p-0 text-center">
          <Skeleton height={155} width="100%" className="mt-2"></Skeleton>

          <div className=" pb-3 border-bottom ">
            <Skeleton height={20} width="100%" className="mt-3"></Skeleton>
          </div>
        </Card.Body>
        <Card.Footer className="bg-white border-top-0 pt-0 px-0 pb-0 rounded-3">
          <Skeleton height={20} width="100%" className="mt-2"></Skeleton>
          <Skeleton height={20} width="100%" className="mt-2"></Skeleton>
        </Card.Footer>
      </Card>
    </div>
  );
}
export default SkeletonAmusementCardItem;
